import React from "react";
import { HeaderProps } from "../HeaderProps";
import "./HeaderMobile.css";
import LogoutIcon from "../../../resources/wrappers/LogoutIcon";
import BackIcon from "../../../resources/wrappers/BackIcon";
import { Button } from "@material-ui/core";
import { Route } from "react-router-dom";
import { AuthService } from "../../../services/authentication/AuthService";
import ConfirmDialog from "../../dialog/ConfirmDialog";
import { GoogleTagManagerService } from "../../../services/analitycs/GoogleTagManagerService";
import HomeMenuIcon from "../../../resources/wrappers/menu/HomeMenuIcon";
import CatalogMenuIcon from "../../../resources/wrappers/menu/CatalogMenuIcon";
import TerminalsMenuIcon from "../../../resources/wrappers/menu/TerminalsMenuIcon";
import UsersMenuIcon from "../../../resources/wrappers/menu/UsersMenuIcon";
import DotsMenuIcon from "../../../resources/wrappers/menu/DotsMenuIcon";
import CloseMenuIcon from "../../../resources/wrappers/menu/CloseMenuIcon";
import ApplicationsIcon from "../../../resources/wrappers/menu/ApplicationsIcon";
import MerchantsIcon from "../../../resources/wrappers/menu/MerchantsIcon";
import $ from "jquery";
import * as _ from "lodash";
import links from "../../footer/links.json";
import StateContextProvider from "../../../context/StateContext";

export class HeaderMobile extends React.Component<HeaderProps, any> {
  private static T_AND_C_KEY = "terms_and_condition";

  constructor(props: HeaderProps) {
    super(props);
    this.doLogout = this.doLogout.bind(this);
    this.state = {
      showDialog: false,
      homeSelected: false,
      catalogSelected: false,
      usersSelected: false,
      terminalsSelected: false,
      applicationsSelected: false,
      merchantsSelected: false,
      linkModalShown: false,
      headerTop: 0,
      modalHeight: 0,
      userType: StateContextProvider.getInstance().getProp("scope"),
    };
  }

  componentDidMount() {
    switch (this.props.selectedElement) {
      case 0:
        this.setState({ homeSelected: true });
        break;
      case 1:
        this.setState({ catalogSelected: true });
        break;
      case 2:
        this.setState({ terminalsSelected: true });
        break;
      case 3:
        this.setState({ usersSelected: true });
        break;
      case 4:
        this.setState({ applicationsSelected: true });
        break;
      case 5:
        this.setState({ merchantsSelected: true });
        break;
      default:
        break;
    }
  }

  private goToTabVoice(history: any, key: string) {
    switch (key) {
      case "home":
        history.push("/");
        break;
      case "catalog":
        history.push("/catalog");
        break;
      case "terminals":
        history.push("/terminals");
        break;
      case "users":
        history.push("/users");
        break;
      case "applications":
        history.push("/applications");
        break;
      case "merchants":
        history.push("/merchants");
        break;

      default:
        break;
    }
  }

  private goToClosePage(history: any) {
    if (this.props.closePage !== undefined) {
      history.replace("/");
      if (this.props.returnState !== undefined) {
        history.push(this.props.closePage, this.props.returnState);
      } else {
        history.push(this.props.closePage);
      }
    }
  }

  private doLogout(history: any) {
    console.log("[Header] do logout called!");
    GoogleTagManagerService.getInstance().pushInteractionEvent("Click", this.props.title !== undefined ? this.props.title : "", "click", "logout confermato");
    AuthService.getInstance()
      .logout()
      .subscribe(
        () => {
          // Nothing to do in onNext
        },
        () => {
          // Nothing to do in onError
        },
        () => {
          // onComplete go to login page!
          history.replace("/login");
        }
      );
  }

  private showLogoutDialog() {
    GoogleTagManagerService.getInstance().pushInteractionEvent(
      "PopupImpression",
      this.props.title !== undefined ? this.props.title : "",
      "impression",
      "conferma logout"
    );
    this.toggleModal();
  }

  private toggleModal = () => {
    GoogleTagManagerService.getInstance().pushInteractionEvent(
      "PopupImpression",
      this.props.title !== undefined ? this.props.title : "",
      "impression",
      "conferma logout"
    );
    this.setState({
      showDialog: !this.state.showDialog,
    });
  };

  private toggleLinkModal() {
    this.setState({ linkModalShown: !this.state.linkModalShown });
    this.makeOverlay();
  }

  private makeOverlay() {
    const appParent = document.getElementById("app-parent");
    const mainChild = appParent?.childNodes[0];
    const header = mainChild?.childNodes[0];
    // @ts-ignore
    let headerClassName = "." + header.className;

    const headerHeight = $(headerClassName)?.height();
    const contentHeight = $("#app-parent")?.height();
    console.log("header: " + headerHeight + "; content: " + contentHeight);
    this.setState({ headerTop: headerHeight });
    this.setState({ modalHeight: contentHeight });
  }

  manageTermsAndConditions(history: any) {
    GoogleTagManagerService.getInstance().pushInteractionEvent("Click", "footer", "click", "termini e condizioni");
    console.log("[HeaderMobile][goToTermsAndConditions] go to T&C page!");
    history.push("/termsAndConditions", { fromHome: true });
  }

  render() {
    return (
      <div
        className={"main-header"}
        style={
          this.props.background
            ? this.props.backgroundImage
              ? {
                backgroundImage: "url(" + this.props.backgroundImage + ")",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                boxShadow: "inset 0 0 0 2000px rgb(0 0 0 / 50%)",
              }
              : { background: this.props.background }
            : { background: "transparent" }
        }>
        {this.props.showMainMenu ? (
          <div className={"header-mobile-main-tab-menu-container"}>
            <Route
              render={({ history }) => {
                return (
                  <div className={"header-mobile-main-tab-tab"} onClick={() => this.goToTabVoice(history, "home")}>
                    <HomeMenuIcon
                      width={"25px"}
                      height={"25px"}
                      fill={this.state.linkModalShown ? "#FFFFFF" : this.state.homeSelected ? "#00B8DE" : "#000000"}
                    />
                  </div>
                );
              }}
            />
            <Route
              render={({ history }) => {
                return (
                  <div className={"header-mobile-main-tab-tab"} onClick={() => this.goToTabVoice(history, "catalog")}>
                    <CatalogMenuIcon
                      width={"25px"}
                      height={"25px"}
                      fill={this.state.linkModalShown ? "#FFFFFF" : this.state.catalogSelected ? "#00B8DE" : "#000000"}
                    />
                  </div>
                );
              }}
            />
            <Route
              render={({ history }) => {
                return (
                  <div className={"header-mobile-main-tab-tab"} onClick={() => this.goToTabVoice(history, "terminals")}>
                    <TerminalsMenuIcon
                      width={"25px"}
                      height={"25px"}
                      fill={this.state.linkModalShown ? "#FFFFFF" : this.state.terminalsSelected ? "#00B8DE" : "#000000"}
                    />
                  </div>
                );
              }}
            />
            <Route
              render={({ history }) => {
                return (
                  <div className={"header-mobile-main-tab-tab"} onClick={() => this.goToTabVoice(history, "users")}>
                    <UsersMenuIcon
                      width={"25px"}
                      height={"25px"}
                      fill={this.state.linkModalShown ? "#FFFFFF" : this.state.usersSelected ? "#00B8DE" : "#000000"}
                    />
                  </div>
                );
              }}
            />
            <Route
              render={({ history }) => {
                return (
                  <div className={"header-mobile-main-tab-tab"} onClick={() => this.goToTabVoice(history, "applications")}>
                    <ApplicationsIcon
                      width={"25px"}
                      height={"25px"}
                      fill={this.state.linkModalShown ? "#FFFFFF" : this.state.applicationsSelected ? "#00B8DE" : "#000000"}
                    />
                  </div>
                );
              }}
            />
            <Route
              render={({ history }) => {
                return (
                  <div className={"header-mobile-main-tab-tab"} onClick={() => this.goToTabVoice(history, "merchants")}>
                    <MerchantsIcon
                      width={"25px"}
                      height={"25px"}
                      fill={this.state.linkModalShown ? "#FFFFFF" : this.state.merchantsSelected ? "#00B8DE" : "#000000"}
                    />
                  </div>
                );
              }}
            />
            <div className={"header-mobile-main-tab-tab"} onClick={() => this.toggleLinkModal()}>
              {this.state.linkModalShown ? (
                <CloseMenuIcon width={"20px"} height={"20px"} fill={"#000000"} />
              ) : (
                <DotsMenuIcon width={"25px"} height={"25px"} fill={"#000000"} />
              )}
            </div>
          </div>
        ) : (
          <div className={this.props.isSpecial ? "base-header-special" : "base-header"} style={this.props.hideBorder ? { border: "none" } : {}}>
            <div className={"header-button-left-container"}>
              <Route
                  render={({ history }) => {
                    const handleGoBack = () => {
                      if (this.props.specificPath) {
                      history.push(this.props.specificPath); // Reindirizza alla rotta specifica
                      } else {
                      history.goBack(); // Utilizza il comportamento predefinito se specificPath non è definito
                      }
                  };
                  return (
                    <Button id={"left-button-header"} onClick={handleGoBack} disabled={!this.props.showBack} disableRipple>
                      {this.props.showBack && (
                        <BackIcon
                          width={"26px"}
                          height={"30px"}
                          fill={this.props.buttonContentColor ? this.props.buttonContentColor : "#000000"}
                          stroke={this.props.buttonContentColor ? this.props.buttonContentColor : "#000000"}
                        />
                      )}
                    </Button>
                  );
                }}
              />
            </div>
            <div className={this.props.isSpecial ? "header-special-title-container" : "header-title-container"}>
              {this.props.showTitle && (
                <p className={"header-title"} style={this.props.titleTextColor ? { color: this.props.titleTextColor } : {}}>
                  {this.props.title?.toUpperCase()}
                </p>
              )}
            </div>
            <div className={"header-button-right-container"}>
              {this.props.showClose ? (
                <Route
                  render={({ history }) => {
                    return (
                      <Button
                        id={"right-button-header"}
                        onClick={() => {
                          this.goToClosePage(history);
                        }}
                        disabled={!this.props.showClose}
                        disableRipple>
                        <CloseMenuIcon width={"20px"} height={"20px"} fill={"#000000"} />
                      </Button>
                    );
                  }}
                />
              ) : (
                <Button
                  id={"right-button-header"}
                  onClick={() => {
                    this.showLogoutDialog();
                  }}
                  disabled={!this.props.showLogout}
                  disableRipple>
                  {this.props.showLogout && (
                    <LogoutIcon
                      width={"30px"}
                      height={"30px"}
                      fill={this.props.buttonContentColor ? this.props.buttonContentColor : "#000000"}
                      stroke={this.props.buttonContentColor ? this.props.buttonContentColor : "#000000"}
                    />
                  )}
                </Button>
              )}
            </div>
          </div>
        )}
        {this.state.linkModalShown && (
          <div className={"header-mobile-tab-modal-container"} style={{ top: this.state.headerTop, height: this.state.modalHeight }}>
            <div className={"header-mobile-tab-modal-content"}>
              <div className={"header-mobile-tab-modal-menu-footer"}>
                <div className={"header-mobile-tab-modal-menu-link"}>
                  {_.map(links.menuMobile, (value: object) => {
                    // @ts-ignore
                    let ref: string = value["ref"] as string;
                    // @ts-ignore
                    let label: string = value["label"];
                    // @ts-ignore
                    let key: string = value["key"];
                    return (
                      <div key={key} className={"header-mobile-link-container"}>
                        {HeaderMobile.T_AND_C_KEY === key ? (
                          <Route
                            render={({ history }) => {
                              return (
                                <p
                                  className={"header-mobile-link"}
                                  key={key}
                                  onClick={() => {
                                    this.manageTermsAndConditions(history);
                                    return false;
                                  }}>
                                  {label}
                                </p>
                              );
                            }}
                          />
                        ) : (
                          <a className={"header-mobile-link"} key={key} href={ref}>
                            {label}
                          </a>
                        )}
                      </div>
                    );
                  })}
                </div>
                <div className={"header-mobile-logout-button-container"}>
                  <Route
                    render={({ history }) => {
                      return (
                        <Button
                          id={"header-mobile-logout-button"}
                          onClick={() => {
                            this.showLogoutDialog();
                          }}>
                          ESCI
                        </Button>
                      );
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={"header-tab-modal-overlay"} style={{ height: this.state.modalHeight - 326 }} />
          </div>
        )}
        {this.props.children}
        {this.state.showDialog && (
          <Route
            render={({ history }) => {
              return (
                <ConfirmDialog
                  show={this.state.showDialog}
                  onClose={this.toggleModal}
                  title={"Log out"}
                  content={"Vuoi davvero uscire dal portale?"}
                  buttonNoText={"ANNULLA"}
                  buttonYesText={"CONFERMA"}
                  onConfirm={() => {
                    this.doLogout(history);
                  }}
                />
              );
            }}
          />
        )}
      </div>
    );
  }
}
